<template>
  <div class="MessageNotification">
    <div class="title">
      <div>信息提示</div>
      <div class="close" @click="close"></div>
    </div>
    <main class="main">
      <div>
        <img ondragstart="return false;" src="../../assets/img/pageCard/XinXiTiShi/G.png" alt="" />
      </div>
      <div>
        <div>派发成功  工单处置中...</div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit('beginMetting')
    },
  },
}
</script>

<style lang="less" scoped>
.MessageNotification {
  width: 370px;
  height: 130px;
  background: url('../../assets/img/pageCard/XinXiTiShi/bg.png') no-repeat 100%;
  pointer-events: all;
  transform: scale(1.5);

  .title {
    height: 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px 7px;
    box-sizing: border-box;
    & > div:nth-child(1) {
      padding-left: 27px;
      font-family: 'Helvetica';
      font-weight: bold;
      font-size: 20px;
      background: linear-gradient(to bottom, #fff, #99ecfb);
      -webkit-background-clip: text;
      color: transparent;
    }

    .close {
      width: 14px;
      height: 14px;
    }
  }

  .main {
    display: flex;
    align-items: center;
    padding: 15px 0 0 38px;
    box-sizing: border-box;
    & > div:nth-child(1) {
      width: 50px;
      height: 50px;
      & > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    & > div:nth-child(2) {
      margin-left: 17px;
      font-size: 16px;
      color: #ffffff;
      font-family: '微软雅黑';
    }
  }
}
</style>
